import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";

export default function RomanToNumber() {
  const { parse } = require("roman-numerals-convert");
  const [roman, setRoman] = useState("");
  const [number, setNumber] = useState("");
  const [err, setErr] = useState(false);
  const [copy, setCopy] = useState("");
  const [value, setvalue] = useState(null);
  const [errors, setErrors] = useState("");

  const handleOnChange = (e) => {
    setRoman("");
    setCopy(false);

    setErr(false);
    setvalue(e.target.value);

    setNumber("");
    if (!e.target.value) return;
    try {
      setRoman(parse(e.target.value));
    } catch (error) {
      setErr(error);
    }
    if (err) {
      toast.error(err.message);
    }
    setErrors("");
  };
  const handleOnSubmit = () => {
    if (validateForm()) {
      setNumber(roman);
    }
  };

  const validateForm = () => {
    let formIsValid = true;
    if (!value) {
      setErrors("* Please enter roman number");
      formIsValid = false;
    }
    return formIsValid;
  };

  return (
    <>
      <div className="commom-box-new">
        <div className="input-new">
          <input
            type="text"
            placeholder="Enter A Roman Number"
            value={value}
            onChange={handleOnChange}
            className={errors && "error-input"}
          ></input>
          <span className="text-sm text-red-700">{errors}</span>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button onClick={handleOnSubmit}>Convert</button>
      </div>
      {roman && (
        <div className="commom-box-new">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(roman)} />
            {copy && (
              <div>
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="input-new">
            <input
              type="text"
              value={number}
              disabled
              className="text-black"
            ></input>
          </div>
        </div>
      )}
    </>
  );
}
